var map = {
	"./01_get_quote_contracts.json": "DcMO",
	"./03_get_quote_depth.json": "e+0O",
	"./04_get_quote_ trades.json": "PqB/",
	"./05_get_quote_ premiumIndex.json": "Tk4L",
	"./06_get_quote_ fundingRate.json": "YtyA",
	"./07_get_quote_ klines.json": "xU+M",
	"./08_get_quote_openInterest.json": "j4uq",
	"./09_get_quote_ ticker.json": "LWb5",
	"./19_get_historicalTrades.json": "xyiP",
	"./20_get_trade_quote_bookTicker.json": "E4EJ",
	"./21_get_quote_mark_price_klines.json": "VeQG",
	"./22_get_quote_price_v2.json": "rCcB",
	"./23_get_trading_rules.json": "fKSd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VeFC";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/api/market \.json$
// module id = VeFC
// module chunks = 3